// Shade ranges keep their per-shade photos out of the PDP gallery (sg_on in
// product-template.liquid), so the gallery opens on the tube / colour chart. When the shopper
// picks a shade, the theme's fast variant update fires `hds:variant-media`; this appends that
// shade's photo as the LAST slide (and thumbnail) and selects it, replacing any previous one.
//
// Appended, not prepended, so every existing cell keeps its index — the theme's thumb
// highlight (theme.js) captures its cell list once at init and would be off by one otherwise.
// The shade cell is a plain <img>: no zoom / lightbox wiring.
//
// Photo URLs come from the #ShadeMedia-<sectionId> JSON island, which only renders when the
// filter is on, so on every other product this is a no-op.
(function () {
  if (window.__pdpShadeGalleryBound) return;
  window.__pdpShadeGalleryBound = true;

  // Desktop hover preload tuning (see "Desktop hover preload" below).
  // A cursor sweeping along the swatch row spends roughly 20-60ms on each swatch; a deliberate
  // pause is 200ms+. For reference, instant.page waits 65ms and hoverIntent ~100ms. 120ms sits
  // above a sweep and well under a pause. Tune it from the pdp_swatch_hover_click rest_ms data.
  var PRELOAD_DWELL_MS = 120;
  // A resting hand still wobbles a few pixels: movement within this radius of where the rest
  // started does not restart the timer.
  var PRELOAD_MOVE_TOLERANCE_PX = 6;

  // The island is compact: {"_t": product title, "<mediaId>": [file?v=, width, height, alt?]}.
  // Expanded here into the shape the rest of this file uses. Parsed once per section.
  var shadeCache = {};
  function readShadeMedia(sectionId) {
    var el = document.getElementById('ShadeMedia-' + sectionId);
    if (!el) return null;
    if (shadeCache[sectionId] && shadeCache[sectionId].el === el) return shadeCache[sectionId].data;
    var raw;
    try {
      raw = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    var base = '/cdn/shop/files/', out = {};
    Object.keys(raw).forEach(function (id) {
      if (id === '_t') return;
      var r = raw[id], u = base + r[0], sep = u.indexOf('?') === -1 ? '?' : '&';
      var at = function (w) { return u + sep + 'width=' + w; };
      out[id] = { src: at(800), srcset: at(400) + ' 400w, ' + at(800) + ' 800w, ' + at(1000) + ' 1000w',
                  w: r[1], h: r[2], alt: r[3] || raw._t || '', thumb: at(200) };
    });
    shadeCache[sectionId] = { el: el, data: out };
    return out;
  }

  function buildCell(mediaId, m) {
    var cell = document.createElement('div');
    cell.className = 'pr_photo pr-shade-slot';
    cell.setAttribute('data-id', 'media' + mediaId);

    var wrap = document.createElement('span');
    wrap.className = 'imgWrapper';
    wrap.style.maxWidth = m.w + 'px';

    var img = document.createElement('img');
    img.className = 'imgFl';
    img.src = m.src;
    img.srcset = m.srcset;
    img.sizes = '(min-width: 768px) 50vw, 100vw';
    img.width = m.w;
    img.height = m.h;
    img.alt = m.alt || '';

    wrap.appendChild(img);
    cell.appendChild(wrap);
    return cell;
  }

  function buildThumb(mediaId, m, onClick) {
    var item = document.createElement('div');
    item.className = 'pr_thumbs_item pr-shade-slot';

    var a = document.createElement('a');
    a.className = 'gitem-img pr_thumb swipeImg';
    a.href = m.src;
    a.title = m.alt || '';
    a.setAttribute('data-target', 'media' + mediaId);
    a.addEventListener('click', function (e) {
      e.preventDefault();
      onClick();
    });

    var img = document.createElement('img');
    img.className = 'imgFt';
    img.src = m.thumb;
    img.width = 100;
    img.height = Math.floor(100 * m.h / m.w);
    img.alt = m.alt || '';

    a.appendChild(img);
    item.appendChild(a);
    return item;
  }

  function swapShade(cell, mediaId, m, sectionId, selectLast) {
    var token = String(mediaId);
    cell.setAttribute('data-pending', token);
    var pre = new Image();
    pre.sizes = '(min-width: 768px) 50vw, 100vw';
    pre.srcset = m.srcset;
    pre.src = m.src;
    var apply = function () {
      if (cell.getAttribute('data-pending') !== token) return; // a later pick has superseded this one
      cell.removeAttribute('data-pending');
      cell.setAttribute('data-id', 'media' + mediaId);
      var wrap = cell.querySelector('.imgWrapper');
      if (wrap) wrap.style.maxWidth = m.w + 'px';
      var img = cell.querySelector('img');
      if (img) {
        img.srcset = m.srcset;
        img.src = m.src;
        img.width = m.w;
        img.height = m.h;
        img.alt = m.alt || '';
      }
      var thumbs = document.querySelector('.pr_thumbs' + sectionId);
      var t = thumbs && thumbs.querySelector('.pr-shade-slot .pr_thumb');
      if (t) {
        t.setAttribute('data-target', 'media' + mediaId);
        t.href = m.src;
        t.title = m.alt || '';
        var ti = t.querySelector('img');
        if (ti) {
          ti.removeAttribute('srcset');
          ti.removeAttribute('data-srcset');
          ti.src = m.thumb;
          ti.alt = m.alt || '';
        }
      }
      selectLast();
    };
    if (pre.complete && pre.naturalWidth) apply();
    else {
      pre.onload = apply;
      pre.onerror = apply;
    }
  }

  function showShade(sectionId, mediaId) {
    var shades = readShadeMedia(sectionId);
    if (!shades) return;
    var m = shades[String(mediaId)];
    if (!m) return; // the variant's photo is a product shot that is already in the gallery

    var slider = document.getElementById('pis' + sectionId);
    if (!slider || typeof jQuery === 'undefined') return;
    var $slider = jQuery(slider);
    var flkty = $slider.data('flickity');
    if (!flkty) return;

    var selectLast = function () {
      $slider.flickity('select', flkty.cells.length - 1, false, false);
    };

    var existing = slider.querySelector('.pr-shade-slot');
    if (existing && existing.getAttribute('data-id') === 'media' + mediaId) {
      selectLast();
      return;
    }
    if (existing) {
      // Swap the picture inside the existing shade slide rather than remove + append: removing the
      // selected cell made Flickity fall back to the tube for a frame before the new shade slid in.
      // The new photo is preloaded first, so the old shade stays on screen until it can be replaced.
      swapShade(existing, mediaId, m, sectionId, selectLast);
      return;
    }

    var cell = buildCell(mediaId, m);
    $slider.flickity('append', cell);
    cell.setAttribute('data-slide', String(flkty.cells.length - 1));

    var thumbs = document.querySelector('.pr_thumbs' + sectionId);
    if (thumbs) {
      var oldThumb = thumbs.querySelector('.pr-shade-slot');
      if (oldThumb) oldThumb.parentNode.removeChild(oldThumb);
      var thumb = buildThumb(mediaId, m, selectLast);
      thumb.setAttribute('data-slide', String(flkty.cells.length - 1));
      thumbs.appendChild(thumb);
    }

    selectLast();
  }

  document.addEventListener('hds:variant-media', function (e) {
    var d = e.detail || {};
    if (!d.sectionId || !d.mediaId) return;
    showShade(d.sectionId, d.mediaId);
  });

  // --- Desktop hover preload ---------------------------------------------------------------
  // When the mouse comes to REST on a shade swatch, fetch that shade's photo so a click shows it
  // instantly. The rest starts when the cursor enters a swatch, anchored at that point; wobble
  // inside PRELOAD_MOVE_TOLERANCE_PX of the anchor keeps it going, moving further (or onto another
  // swatch) re-anchors and restarts it, leaving the swatch cancels it. Mouse only: touch has no
  // hover, and on phones the tap is the first signal anyway. Each photo is preloaded once a page.
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var preloaded = {};
  var dwell = null; // { label, x, y, anchorAt, enteredAt, timer, fired }

  function readVariants(sectionId) {
    var el = document.getElementById('VariantData-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // What the preload and the timing event need about a swatch, or null if it isn't a shade
  // swatch on a product with the shade gallery.
  function swatchInfo(label) {
    var scope = label.closest('[data-section-id]');
    var sectionId = scope && scope.getAttribute('data-section-id');
    var input = label.htmlFor && document.getElementById(label.htmlFor);
    if (!sectionId || !input) return null;
    var shades = readShadeMedia(sectionId);
    if (!shades) return null;
    var variantId = input.getAttribute('data-variant-id');
    var variants = readVariants(sectionId) || [];
    var mediaId = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === variantId) { mediaId = variants[i].featured_media_id; break; }
    }
    return { sectionId: sectionId, variantId: variantId, shade: input.value, mediaId: mediaId,
             media: mediaId ? shades[String(mediaId)] : null };
  }

  function preloadFor(label) {
    var info = swatchInfo(label);
    var m = info && info.media;
    if (!m || preloaded[info.mediaId]) return;
    preloaded[info.mediaId] = true;
    var img = new Image();
    img.fetchPriority = 'low';
    img.sizes = '(min-width: 768px) 50vw, 100vw'; // same sizes/srcset as the slide, so the browser
    img.srcset = m.srcset;                           // fetches the exact candidate the slide will use
    img.src = m.src;
  }

  function armDwell(label, x, y, enteredAt) {
    if (dwell && dwell.timer) clearTimeout(dwell.timer);
    var d = { label: label, x: x, y: y, anchorAt: Date.now(), enteredAt: enteredAt, timer: null, fired: false };
    d.timer = setTimeout(function () {
      d.timer = null;
      if (dwell === d) {
        d.fired = true;
        preloadFor(label);
      }
    }, PRELOAD_DWELL_MS);
    dwell = d;
  }

  function stopDwell() {
    if (dwell && dwell.timer) clearTimeout(dwell.timer);
    dwell = null;
  }

  // --- Rest-before-click timing, so PRELOAD_DWELL_MS can be tuned from real cursors ----------
  // One `pdp_swatch_hover_click` per mouse click on a shade swatch, sent to the metrics collector
  // like pdp-shade-engagement.js / my-prices.js. Hovers that never lead to a click send nothing.
  // Fields land in analytics_events.payload -> $.swatch_hover.*:
  //   rest_ms    time from the last anchor (entering the swatch, or the last move beyond the
  //              tolerance) to the click
  //   hover_ms   time from entering the swatch to the click
  //   preloaded  whether the preload had fired before the click
  //   dwell_ms / tolerance_px  the settings live at the time, so rows stay readable after tuning
  var COLLECT = 'https://metrics.hairdressingsupplies.com/collect';
  var ids = { session_id: null, visitor_id: null };
  var pending = [];

  function send(body) {
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(COLLECT, body);
      else if (window.fetch) window.fetch(COLLECT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () {});
    } catch (e) { /* analytics must never break the page */ }
  }

  function flushPending() {
    while (pending.length) send(JSON.stringify(pending.shift()));
  }

  // The web pixel's session/visitor ids are only readable from its postMessage broadcast; hold
  // the event until it arrives (about a second) so the row joins to the session.
  window.addEventListener('message', function (e) {
    try {
      var p = e && e.data && e.data.type === 'hsuk_pixel_event' && e.data.payload;
      if (!p) return;
      if (p.session_id) ids.session_id = p.session_id;
      if (p.visitor_id) ids.visitor_id = p.visitor_id;
      if (ids.session_id && pending.length) flushPending();
    } catch (err) { /* ignore */ }
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && pending.length) flushPending(); // leaving: send anyway
  });

  function trackRestClick(d) {
    try {
      var info = swatchInfo(d.label);
      if (!info) return;
      var now = Date.now();
      pending.push({
        event_name: 'pdp_swatch_hover_click',
        event_id: 'pdp_swatch_hover_click_' + now + '_' + Math.random().toString(36).slice(2, 11),
        client_name: 'Shopify Theme',
        timestamp: new Date(now).toISOString(),
        timestamp_unix: now,
        session: { session_id: ids.session_id },
        visitor: { visitor_id: ids.visitor_id },
        page: { path: location.pathname, location: location.href, title: document.title },
        device: { user_agent: navigator.userAgent || '', viewport_width: window.innerWidth || null },
        user_data: { customer_id: window.__b2b_customer_id || null },
        ecommerce: { currency: 'GBP', items: [{ item_id: info.variantId, item_variant: info.shade, quantity: 1 }] },
        swatch_hover: {
          rest_ms: now - d.anchorAt, hover_ms: now - d.enteredAt, preloaded: d.fired,
          dwell_ms: PRELOAD_DWELL_MS, tolerance_px: PRELOAD_MOVE_TOLERANCE_PX, shade: info.shade
        }
      });
      if (ids.session_id) flushPending();
    } catch (e) { /* never break the page */ }
  }

  if (canHover) {
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var label = e.target.closest && e.target.closest('label.swatchLbl');
      if (!label) {
        if (dwell) stopDwell();
        return;
      }
      if (!dwell || dwell.label !== label) {
        armDwell(label, e.clientX, e.clientY, Date.now()); // entered a (different) swatch
        return;
      }
      var dx = e.clientX - dwell.x, dy = e.clientY - dwell.y;
      if (dx * dx + dy * dy > PRELOAD_MOVE_TOLERANCE_PX * PRELOAD_MOVE_TOLERANCE_PX) {
        armDwell(label, e.clientX, e.clientY, dwell.enteredAt); // moved on: re-anchor, restart
      }
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (dwell && e.target.closest && e.target.closest('label.swatchLbl') === dwell.label &&
          !(e.relatedTarget && dwell.label.contains(e.relatedTarget))) {
        stopDwell();
      }
    }, { passive: true });
    // Capture phase, so the rest is read before the theme reacts to the click.
    document.addEventListener('click', function (e) {
      var label = e.target.closest && e.target.closest('label.swatchLbl');
      if (label && dwell && dwell.label === label) trackRestClick(dwell);
    }, true);
  }
})();
